import { Straight, StarBorder } from '@mui/icons-material';
import { IconButton, Stack, Tooltip, Typography } from '@mui/material';
import { useMyAssortmentTFunction } from '@retail/my-assortment/i18n';
import { SupplierPriorityItem } from './supplierPriorityTier';

interface Props {
  supplier: SupplierPriorityItem;
  canMoveUp: boolean;
  canMoveDown: boolean;
  onMoveUp: () => void;
  onMoveDown: () => void;
}

export function SupplierPriorityRow({
  supplier,
  canMoveUp,
  canMoveDown,
  onMoveUp,
  onMoveDown,
}: Props) {
  const t = useMyAssortmentTFunction();

  return (
    <Stack
      direction="row"
      alignItems="center"
      gap={1}
      sx={{
        px: 1.5,
        py: 1,
        borderRadius: 1.5,
        bgcolor: 'background.paper',
        border: (theme) => `1px solid ${theme.vars.palette.divider}`,
      }}
    >
      {supplier.tier === 'MAIN' && (
        <Tooltip title={t('myAssortment.priority.mainPrioSupplier')} placement="top" arrow>
          <StarBorder color="success" fontSize="small" sx={{ flexShrink: 0 }} />
        </Tooltip>
      )}
      <Typography variant="body2" flexGrow={1} noWrap title={supplier.supplierName}>
        {supplier.supplierName}
      </Typography>
      <Stack direction="row" flexShrink={0}>
        <IconButton
          size="small"
          sx={{ p: 0.25 }}
          disabled={!canMoveUp}
          onClick={onMoveUp}
          aria-label={t('myAssortment.priority.prioritized')}
        >
          <Straight fontSize="small" />
        </IconButton>
        <IconButton
          size="small"
          sx={{ p: 0.25 }}
          disabled={!canMoveDown}
          onClick={onMoveDown}
          aria-label={t('myAssortment.priority.unprioritized')}
        >
          <Straight sx={{ rotate: '180deg' }} fontSize="small" />
        </IconButton>
      </Stack>
    </Stack>
  );
}
